
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64","width":"300","height":"300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.139 33.226c1.584.158 5.069.158 5.069 2.376 0 3.009-4.435 6.969-11.563 11.246C5.428 48.274.833 50.49.833 53.5c0 2.376 1.743 4.118 5.386 3.643 3.485-.475 8.871-2.851 15.998-8.87 7.445-6.178 14.414-16.474 14.414-26.611 0-10.296-6.969-20.592-18.216-20.592-9.028 0-16.79 6.81-16.79 16.157.001 7.128 4.911 15.364 12.514 15.998z"}}),_c('path',{attrs:{"d":"M36.406 37.68a11.158 11.158 0 004.268 1.253c1.584.158 5.069.158 5.069 2.376 0 3.009-4.435 6.969-11.563 11.246-2.218 1.426-6.811 3.643-6.811 6.653 0 2.376 1.743 4.118 5.386 3.643 3.485-.475 8.871-2.851 15.998-8.87 7.444-6.178 14.414-16.474 14.414-26.612 0-10.296-6.969-20.592-18.216-20.592a17.52 17.52 0 00-7.441 1.649c2.219 4.012 3.402 8.654 3.402 13.236-.001 5.658-1.823 11.145-4.506 16.018z"}})])
          )
        }
      }
    